/*
 * Copyright (c) 2020 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

export const ro = {
  'auth': {
    'username': 'Nume utilizator',
    'password': 'Parola',
    'passwordExample': 'Exp: parolagauss',
    'login': 'Autentificare',
    'login-details': 'Date autentificare',
    'password-recovery-request-link': 'Ti-ai uitat parola? Apasa aici!',
    'error': {
      'Bad credentials': 'Nume utilizator sau parolă incorectă!',
      'expired-user': 'Utilizatorul nu mai este activ',
      'disabled-user': 'Adresa de e-mail a utilizatorului nu a fost confirmată',
      '504': 'Ne pare rau, dar autentificarea nu este posibila momentan!',
      'undefined': 'Ne pare rau, dar autentificarea nu este posibila momentan!'
    },
    'resend-email-confirmation':{
      'button': 'Retrimitere email confirmare',
      'success': 'Mailul de confirmare a fost retrimis cu success. Va rog sa verificati e-mail-ul!',
      'error': 'Nu s-a putut retrimite mailul de confirmare!'
    },
    'profileInfoChanged': 'Profilul a fost actualizat cu success! Te rugam sa te loghezi din nou pentru ca modificarile sa fie vizibile.'
  }
};
